(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .component('patrimoineFinanceGraph', {
        templateUrl: 'partials/patrimoine/patrimoine_finance.html',
        controller: PatrimoineFinanceCtrl,
        controllerAs: '$ctrl'
    });


    function PatrimoineFinanceCtrl($scope, $q, TasksStatisticsService, swif, swifPatrimoineService) {
        'ngInject';
        console.log('init PatrimoineFinanceController');
        var $ctrl = this;
        $ctrl.referentiel = swifPatrimoineService.referentiel.data.referentiel;
        $scope.$watchGroup(['$ctrl.referentiel.currentItem', '$ctrl.year'], watchCurrentItem);

        $ctrl.showContracts = false;
        $ctrl.toggleContracts = toggleContracts;

        $ctrl.length_amort_by_year = function () {
            var purchasePriceFromDomaines = $ctrl.referentiel.currentItem.purchase_price_from_domaines;
            return purchasePriceFromDomaines/($ctrl.referentiel.currentItem.length_amort/12);
        };

        var statsService = TasksStatisticsService;

        $ctrl.pieChartOptions = {
            chart: {
                type: 'pieChart',
                height: 450,
                width: 800,
                x: function(d){return d.key;},
                y: function(d){return d.y;},
                showLabels: true,
                duration: 500,
                labelSunbeamLayout: true,
                legendPosition: 'right',
                tooltip: {
                    contentGenerator: function (e) {
                        var series = e.series[0];
                        if (series.value === null) return;
                        return "<h4>" + series.key + "</h4>" +
                            "<p>" +  series.value + " <swif-currency></swif-currency></p>";
                    }
                }
            }
        };

        $ctrl.lineChartOptions = {
            chart: {
                type: 'lineChart',
                height: 450,
                width: 800,
                margin: {
                    left: 50,
                    right: 50
                },
                useInteractiveGuideline: true,
                x: function(d){
                    return d.x;
                },
                y: function(d){
                    return d.y;
                },
                xAxis: {
                    tickFormat: function (d) {
                        return d3.time.format('%m/%Y')(new Date(d));
                    }
                },
                yAxis: {
                    tickFormat: function (d) {
                        return d3.format(',f')(d).replace(',',' ') + '€';
                    }
                }
            }
        };

        $ctrl.choices = {
            years: []
        };

        $ctrl.year = moment().year();

        $ctrl.options = {
            years: _.range(2012, $ctrl.year + 1)
        };

        $ctrl.loading = {tasks: {}};

        update();
        function update() {
            if ($ctrl.referentiel.contentType === 'patrimoine_site') {
                $ctrl.isSite = true;
                $ctrl.isEquipment = false;
            }
            if ($ctrl.referentiel.contentType === 'patrimoine_equipment') {
                $ctrl.isEquipment = true;
                $ctrl.isSite = false;
            }
            updateChartData();
            loadContracts();
        }
        function watchCurrentItem(newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                update();
            }
        }

        function getProjectFilters() {
            var id = $ctrl.referentiel.currentItem.id;
            var filter = {};
            if ($ctrl.isSite) {
                swif.data.addFilter(filter, 'task_id.site1', 'child_of', id);
            } else if ($ctrl.isEquipment) {
                swif.data.addFilter(filter, 'task_id.equipment_id', '=', id);
            }
            swif.data.addFilter(filter, 'effective_hours', '>', 0);
            swif.data.addFilter(filter, 'date_start', '<', $ctrl.year.toString() + '-12-31');
            swif.data.addFilter(filter, 'date_end', '>', $ctrl.year.toString() + '-01-01');

            var task_filter = angular.copy(filter);
            swif.data.addFilter(task_filter, '|');
            swif.data.addFilter(task_filter, 'project_id', '=', false);
            swif.data.addFilter(task_filter, 'project_id.project_type', '=', 'intervention');

            var contract_filter = angular.copy(filter);
            swif.data.addFilter(contract_filter, 'project_id.project_type', '=', 'contract');
            return {
                tasks: task_filter,
                contract_tasks: contract_filter
            };
        }
        function updateChartData() {
            swif.message.loading($ctrl.loading.tasks);
            /*[
                [
                    ["effective_hours", ">", 0],
                    ["date_start", ">=", "2013-06-01"],
                    ["date_start", "<=", "2014-12-31"],
                    ["site1", "in", [12]]
                ],
                ["effective_hours", "hr_cost", "date_start"],
                ["date_start"]
            ]*/
            $ctrl.lineChartData = [];
            $ctrl.pieChartData = [];
            var filters = getProjectFilters();
            $q.all([
                statsService.groupBy('date_start', false, filters.tasks.domain),
                // statsService.groupBy('category_id', 'date_start', filters.tasks.domain),
                statsService.groupBy('category_id', false, filters.tasks.domain),
                statsService.groupBy('date_start', false, filters.contract_tasks.domain),
                // statsService.groupBy('category_id', 'date_start', filters.contract_tasks.domain)
                statsService.groupBy('category_id', false, filters.contract_tasks.domain),
                loadCarburant()
            ]).then(function (data) {
                $ctrl.task_data = data;
                swif.message.loading($ctrl.loading.tasks, 'ok');
                computeTotalCost(data);
                // TODO: on empty Arrays, set default value [Date('year-01-01'), 0]
                // => (nvd3 raises silent errors when mouseover an empty Chart)
                var lineChartData = [];
                if (data[0].data.task_cost.length) {
                    lineChartData.push({
                        key: swif.i18n.getString('Intervention Costs'),
                        values: data[0].data.task_cost
                    });
                }
                if (data[2].data.task_cost.length) {
                    lineChartData.push({
                        key: swif.i18n.getString('Contracts Costs'),
                        values: data[2].data.task_cost
                    });
                }
                if (data[4].length) {
                    lineChartData.push({
                        key: 'Consommation',
                        values: data[4]
                    });
                }
                $ctrl.lineChartData = lineChartData.map(function(series) {
                    series.values = series.values.map(function(d) { return {x: d[0], y: d[1] } });
                    return series;
                });
                var pieChartData = [];
                _.forEach(data[1].data.task_cost, function (item) {
                    pieChartData.push({key: item[0], y: item[1]});
                });
                _.forEach(data[3].data.task_cost, function (item) {
                    pieChartData.push({key: item[0], y: item[1]});
                });
                $ctrl.pieChartData = pieChartData;
            }, function (error) {
                swif.message.loading($ctrl.loading.tasks, 'ko');
                $q.reject(error);
            });
        }

        // update charts data when initializing the controller
        function getContractsFilter() {
            var filter = {};
            var id = $ctrl.referentiel.currentItem.id;
            filter.fields = ['id', 'complete_name', 'project_cost', 'partner_id', 'date'];
            swif.data.addFilter(filter, 'is_contract', '=', true);
            swif.data.addFilter(filter, 'date_start', '<=', $ctrl.year.toString() + '-12-31');
            swif.data.addFilter(filter, 'date', '>=', $ctrl.year.toString() + '-01-01');
            swif.data.addFilter(filter, 'project_cost', '!=', false);
            swif.data.addFilter(filter, 'project_cost', '!=', 0);

            if ($ctrl.isSite) {
                swif.data.addFilter(filter, 'site_ids', 'child_of', id);
            } else if ($ctrl.isEquipment) {
                swif.data.addFilter(filter, 'equipment_ids', '=', id);
            }
            return filter;
        }
        function SUM(sum, num) {
            return sum + num;
        }
        function loadContracts() {
            $ctrl.contracts = [];
            swif.data.searchRead('patrimoine_contract', getContractsFilter())
            .then(function (items) {
                $ctrl.contracts = items.records;
                $ctrl.total_contracts_price = 0;
                var array = _.map(items.records, function (item) {
                    return item.project_cost;
                });
                if (array.length > 0) {
                    $ctrl.total_contracts_price = array.reduce(SUM);
                }
            });
        }
        function toggleContracts() {
             $ctrl.showContracts = !$ctrl.showContracts;
        }
        function computeTotalCost(data) {
            var inter_cost = data[0].data.task_cost;
            var contract_cost = data[2].data.task_cost;
            function getPrice (item) {
                return item[1];
            }
            $ctrl.inter_task_cost = 0;
            $ctrl.contract_task_cost = 0;
            if (inter_cost.length) {
                $ctrl.inter_task_cost = _.map(inter_cost, getPrice).reduce(SUM);
            }
            if (contract_cost.length) {
                $ctrl.contract_task_cost = _.map(contract_cost, getPrice).reduce(SUM);
            }
        }
        function getCarburantFilter() {
            var filter = {
                fields: ['id', 'date', 'oil_price']
            };
            swif.data.addFilter(
                filter, 'equipment_id', '=', $ctrl.referentiel.currentItem.id
            );
            swif.data.addFilter(filter, 'date', '<=', $ctrl.year.toString() + '-12-31');
            swif.data.addFilter(filter, 'date', '>=', $ctrl.year.toString() + '-01-01');
            return filter;
        }
        function loadCarburant() {
            if (!$ctrl.isEquipment) {
                return $q.when([]);
            }
            function getValues(item) {
                item.__is_date = true;
                var date = statsService._getDefaultVal(item, 'date');
                return [date, item.oil_price];
            }
            var filter = getCarburantFilter();
            //swif.data.searchRead('equipment_line', filter)
            return swif.data.groupRead(
                'equipment_line',
                filter,
                ['date']
            ).then(function (results) {
                return _.map(results, getValues);
            });
        }
    }

})();
